import { motion } from 'framer-motion';
import styled, { keyframes } from 'styled-components';
import { getOptimalTextColor } from '~/utils/getGridColors';

const pulseShadow = (color: string) => keyframes`
  0% {
    box-shadow: 0 0 5px ${color}33;
  }
  50% {
    box-shadow: 0 0 12px ${color};
  }
  100% {
    box-shadow: 0 0 5px ${color}33;
  }
`;

const getTopValue = (props: {
  isBlocked?: boolean;
  showTable?: boolean;
  codTela?: number;
}) => {
  if (
    props.isBlocked ||
    (props.codTela === 58 && !props.isBlocked && !props.showTable)
  )
    return '5.1rem';

  if (!props.showTable) return '8.2688rem';

  if (props.codTela === 222) return '7.5625rem';

  return '5.0625rem';
};

const isNearWhite = (color: string): boolean => {
  const hex = color.trim().toLowerCase();

  const match = hex.match(/^#([0-9a-f]{6})$/i);
  if (!match) return false;

  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

  return luminance > 240;
};

export const Container = styled.div.attrs({
  className: 'container',
})`
  .MuiLinearProgress-colorPrimary {
    background-color: #fff !important;
  }
  .MuiLinearProgress-barColorPrimary {
    background-color: #c2a0f8 !important;
  }
  .containerMaterial {
    min-width: fit-content;
    width: auto;
    padding: 0px 4px;
    order: 1;
    margin: 0px 64px 2px 0px;
  }
  .linkMaterial {
    font-size: 14px;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ContainerButtonsHandler = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  /* align-items: center; */
  margin-bottom: 2px;

  .content-filtros {
    display: flex;
    align-items: center;
    justify-content: center;

    .button-return-cards {
      padding-top: 0.9375rem;
    }
  }

  .container-button-visualizacao {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;

    gap: 0.5rem;

    .content-buttons {
      display: flex;
      align-items: center;
      justify-content: center;

      .btn-gerar-relatorio {
        background-color: #57069e;
        color: white;
        padding: 0.5rem 1rem;
        border: 1px solid transparent;
        border-left-color: white;

        height: 2.5rem;
        min-width: 2.5625rem;

        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;

        &:disabled {
          background-color: #d8d8d8;
          color: #8a8a8a;
          cursor: not-allowed;
        }
      }
    }
  }
`;

export const DisplayFlex = styled.div`
  display: flex;
  flex: 1;
  background-color: white;

  .container-button-add-new {
    width: 100%;
    display: inline-flex;
    justify-content: flex-end;
    margin-bottom: 0.6875rem;
  }

  @media screen and (max-width: 1199px) {
    flex-wrap: wrap;
  }
`;

export const ContainerOrder = styled.div`
  @media (min-width: 500px) {
    margin-right: 10px;
  }
`;

export const ButtonReturnCards = styled(motion.button)`
  padding: 8px 16px;
  height: 40px;
  border-radius: 4px;
  border: none;
  min-width: 150px;
  max-width: 100%;
  background-color: #ffc107;
  color: #fff;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  font-size: 14px;
  font-weight: 500;
  font-family: 'Jost', sans-serif;
  line-height: 26.01px;
  white-space: nowrap;

  svg {
    font-size: 20px;
  }

  animation: all 0.25s ease-in;

  &.addNew {
    background-color: #007bff;
    text-transform: uppercase;
  }

  &.ordenar {
    background-color: rgb(51, 185, 21);
  }

  &:disabled {
    background-color: #f1e1b0;
    cursor: not-allowed;
    &:hover {
      background-color: #f1e1b0;
      opacity: 1;
    }
  }

  &:hover {
    opacity: 0.7;
  }
`;

export const SectionSearchContainer = styled.div<{
  showTable?: boolean;
  cor?: string;
  filtroNaoEditado?: boolean;
}>`
  width: 100%;

  h2 {
    font-size: 18px;
    height: 25px;
    display: flex;
    justify-content: right;
    align-content: top;
    background-color: white;
    margin: 0px !important;

    svg {
      margin-left: 10px;
      margin-right: 5px;
    }

    .span-filtro-ativo {
      background-color: ${(props) => (props.cor ? props.cor : 'white')};
      box-shadow: 1px 1px 2px 1px
        ${(props) =>
          props.cor && isNearWhite(props.cor)
            ? 'rgb(0, 0, 0, 0.5)'
            : props.cor};

      padding: 0.2813rem 0.3438rem;
      font-size: 0.8125rem;
      text-align: center;
      color: ${(props) => props.cor && getOptimalTextColor(props.cor)};
      border-radius: 0.2188rem;
      animation: ${({ filtroNaoEditado, cor }) =>
          !filtroNaoEditado
            ? pulseShadow(cor && isNearWhite(cor) ? '#313638' : cor ?? 'black')
            : 'none'}
        1.5s infinite ease-in-out;
    }
  }
  input.search {
    width: calc(
      100% - ${(props) => (props.showTable ? '1.5625rem' : '2.8125rem')}
    );
    padding: 3px 20px 3px 35px;
    height: 41px;
    margin-right: 10px;
    border: 1px solid ${({ theme: { colors } }) => colors.primary};
    border-radius: 4px;
    box-sizing: border-box;

    &:focus {
      & ~ .fields {
        display: block;
      }
    }
    &:disabled {
      cursor: not-allowed;
    }
  }
  position: relative;

  .filters {
    display: flex;
    padding: 10px 0px;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }
`;
export const Fields = styled.div<{
  showTable?: boolean;
  isBlocked?: boolean;
  codTela?: number;
}>`
  width: calc(
    100% - ${(props) => (props.showTable ? '11.875rem' : '4.6875rem')}
  );
  padding: 20px;
  box-shadow: rgba(9, 30, 66, 0.25) 0px 10px 15px 1px;
  margin-top: 0;
  position: absolute;
  background-color: ${({ theme: { colors } }) => colors.background};
  display: none;
  z-index: 5;
  border-radius: 0px 0px 15px 15px;
  border: 0.0625rem solid rgb(87, 6, 158);
  border-top-color: rgba(0, 0, 0, 0);
  top: ${getTopValue};
  left: ${(props) => (props.showTable ? '11.8125rem' : '0.9375rem')};

  ul {
    display: table;
    border-collapse: collapse;
    margin: 0;
    padding: 0;
    table-layout: fixed;
    width: 100%;

    .container-listaDeFiltrosOrdenados {
      display: table-row;

      .listaDeFiltrosOrdenados {
        display: table-cell;
        padding: 1px;

        button {
          background-color: transparent;
          border: none;
          color: ${({ theme: { colors } }) => colors.primary};
          text-align: left !important;
          width: 100%;
          padding: 9px;
          border-radius: 5px;

          &:active,
          &:hover,
          &:focus {
            color: ${({ theme: { colors } }) => colors.background};
            background-color: ${({ theme: { colors } }) => colors.primary};
          }

          small {
            font-size: 10px;
            color: ${({ theme: { colors } }) => colors.secondary};
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    ul {
      display: flex !important;
      flex-direction: column !important;
      li {
        display: flex !important;
        flex-direction: column !important;
        .listaDeFiltrosOrdenados {
          display: inline-block !important;
        }
      }
    }
  }
`;
export const SearchBarContainer = styled.div<{ showTable?: boolean }>`
  position: relative;
  flex: 1;
  z-index: 5;
  height: 100%;
  display: flex;
  align-items: center;

  padding: 0px;

  svg:first-child {
    position: absolute;
    left: 8px;
    color: ${({ theme: { colors } }) => colors.primary};
    cursor: text;
    outline: none;
    transition: 0.3s ease;
    z-index: 10;
  }

  .btns {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;

    padding: 0px;

    .button-step-by-step {
      width: 2.5625rem;
      height: 2.5625rem;
      border-radius: ${(props) =>
        props.showTable ? '0px' : '0.25rem'} !important;
      border: none;
    }

    .btn-visualiza-campos {
      background: transparent;
    }

    @media (max-width: 700px) {
      position: relative;
      margin-top: 10px;
    }

    button:not(.btn-visualiza-campos) {
      height: 41px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #57069e;
      margin-right: 1px;
      color: #ffffff !important;

      &:hover {
        opacity: 0.85;
      }

      &:nth-child(3n) {
        border-left: 0;
      }

      &:nth-child(2n) {
        border-left: 0;
      }

      &:last-child {
        border-radius: 0px 4px 4px 0px;
      }

      @media (max-width: 700px) {
        &:first-child {
          border-radius: 4px 0px 0px 4px;
        }
      }

      svg {
        font-size: 17.49px;
      }
    }
  }
`;
